module.exports = __webpack_public_path__ + "8768517dc04307f6b8350d301c88d394.svg";